module.exports = __webpack_public_path__ + "media/images/wedding/16-21bc61df1750f79ce0868e616eb2e744.jpg";